/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/marketing/api-affiliates.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

import React from 'react';


/*----------------------------------
- APP
----------------------------------*/

import AffiliatesApiDocumentationPage from '@/client/components/marketing/api/AffiliatesApiDocumentationPage';

/*----------------------------------
- ROUTE
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/api/affiliates', { ...({
    static: {
        refresh: '1h',
        urls: ['/api/affiliates'],
    },
}), ...{ filepath: "/app/client/pages/marketing/api-affiliates.tsx", sourceLocation: { line: 14, column: 1 }, id: "marketing_api_affiliates" } }, null, ({ request }) => {
    return <AffiliatesApiDocumentationPage currentOrigin={new URL(request.url).origin} />;
});
};
